import styled from "styled-components";
import { Link as LinkRouter } from "react-router-dom";
import { Link as LinkScroll } from "react-scroll";

export const Nav = styled.nav`
  background: ${({ scrollNav }) => (scrollNav ? "#809A6F" : "#809A6F")};
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.5rem;
  position: sticky;
  top: 0;
  z-index: 10;
  

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavBarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px:
    max-width: 1100px;
    background: "transparent";
    transition: "ease-in all 0.5s",
`;

export const NavLogo = styled(LinkRouter)`
  color: #64954b;
  justify-content: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-left: 24px;
  font-weight: bold;
  text-decoration: none;
  

`;
export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 960px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
  
  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
    border-buttom: 3px solid #e78ea9;
    
  }
`;
export const NavLink = styled(LinkScroll)`
  color: #fff;
  text-decoration: none;
  align-items: center;
  cursor: pointer;
  height: 100%;
  padding: 0 1rem;
  display: flex;
  

  &.active {
    border-buttom: 3px solid #e78ea9;
  }
  &:hover {
    color: #101010;
    
  }
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const NavBtnLink = styled(LinkRouter)`
  border-radius: 50px;
  background: #64954b;
  white-space: nowrap;
  padding: 10px 22px;
  font-size: 16px;
  border: none;
  cursor: pointer;
  color: #010606;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #64954b;
  }
`;

export const CvLink = styled.a`

`;

export const CvDownloadButton = styled.button`
  color: #fff;
  background: transparent;
  border: 2px solid #fff;
  border-radius: 50px;
  ${'' /* font-weight: bold; */}
  font-size: 1rem;
  font-family: "Oswald";
  padding: 0.5rem 1rem;
  cursor: pointer;
  margin: 0.5rem;
  &:hover {
    color: #101010;
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
    cursor: pointer;
  }
`;
